module.exports = __webpack_public_path__ + "static/perfect performance-c38fb8a39714f4f61c1be31737a15805.png";